import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";

import axios from "axios";
import Swal from "sweetalert2";

import ObtieneDatosCookies from "../tools/obtieneDatosCookiesUsuario";
import comprueboPermisos from "../tools/comprueboPermisos";
import socket from "../tools/socke";

import ModalSancion from "./Modal";
import Sancion from "./Sancion";

import "./Sancionaa.css";

const ObtieneSancionesANotificarFirmes = ({ refresca }) => {
  const Usuario = ObtieneDatosCookies();

  // ============================================================
  // ESTADOS
  // ============================================================

  const [listadoSanciones, setListadoSanciones] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState("");

  const [
    sancionSeleccionada,
    setSancionSeleccionada,
  ] = useState(null);

  const [
    veoDatosSancion,
    setVeoDatosSancion,
  ] = useState(false);

  // ============================================================
  // TOKEN
  // ============================================================

  const obtenerToken = () => {
    const username = process.env.REACT_APP_KEY;
    const password = process.env.REACT_APP_PASS;

    return btoa(`${username}:${password}`);
  };

  // ============================================================
  // OBTENER SANCIONES FIRMES
  // ============================================================

  const obtieneSancionesANotificarFirmes =
    useCallback(async () => {
      if (!Usuario?.id) {
        return;
      }

      try {
        setCargando(true);
        setError("");

        let sede = null;

        if (
          comprueboPermisos(
            Usuario?.funcion,
            "Cuerpo"
          )
        ) {
          sede =
            Number(Usuario?.sedeID) === 2
              ? "Rosario"
              : "Recreo";
        }

        const response = await axios.post(
          "https://wwwa.isepsantafe.net.ar/expedientes/Ncadetes/devuelveSancionesANotificarFinal/",
          {
            sede,
          }
        );

        setListadoSanciones(
          Array.isArray(response?.data)
            ? response.data
            : []
        );
      } catch (error) {
        console.error(
          "Error obteniendo sanciones firmes:",
          error
        );

        setListadoSanciones([]);

        setError(
          "No se pudieron obtener las sanciones firmes pendientes de notificación."
        );
      } finally {
        setCargando(false);
      }
    }, [
      Usuario?.id,
      Usuario?.funcion,
      Usuario?.sedeID,
    ]);

  // ============================================================
  // CERRAR MODAL
  // ============================================================

  const cerrarModal = () => {
    setVeoDatosSancion(false);
    setSancionSeleccionada(null);
  };

  // ============================================================
  // NOTIFICAR SANCION FIRME
  // ============================================================

  const notificarSancion = async (
    sancion
  ) => {
    try {
      const confirmacion = await Swal.fire({
        title: "Notificar sanción firme",
        text:
          "Se registrará la notificación final de la sanción y la actuación quedará finalizada.",
        icon: "question",
        showCancelButton: true,
        confirmButtonText:
          "Registrar notificación",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#315f64",
      });

      if (!confirmacion.isConfirmed) {
        return;
      }

      const token = obtenerToken();

      const payload = {
        fechaNotificadoConfirma:
          new Date(),

        usuarioNotificaConfirma:
          `${Usuario?.nombre || ""} ${
            Usuario?.apellido || ""
          }`.trim(),

        estado: "Finalizada",
      };

      const response = await axios.post(
        `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/actualizaSancion/${sancion.id}`,
        payload,
        {
          headers: {
            Authorization:
              `Basic ${token}`,
          },
        }
      );

      if (response?.data?.success) {
        await Swal.fire({
          title: "Sanción notificada",
          text: `Se registró correctamente la notificación final de la sanción del cadete DNI ${sancion.cadeteDni}.`,
          icon: "success",
          confirmButtonText: "Aceptar",
        });

        socket.emit(
          "sancionEvent",
          sancion.cadeteDni
        );

        cerrarModal();
        obtieneSancionesANotificarFirmes();

        return;
      }

      Swal.fire({
        title:
          response?.data?.message ||
          "No se pudo notificar",
        text:
          "Compruebe los datos e intente nuevamente.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    } catch (error) {
      console.error(
        "Error notificando sanción firme:",
        error
      );

      Swal.fire({
        title: "Error",
        text:
          "No se pudo registrar la notificación final.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    }
  };

  // ============================================================
  // SOCKET
  // ============================================================

  useEffect(() => {
    obtieneSancionesANotificarFirmes();

    const handleActualizacion = () => {
      obtieneSancionesANotificarFirmes();
    };

    socket.on(
      "estadoActualizable",
      handleActualizacion
    );

    return () => {
      socket.off(
        "estadoActualizable",
        handleActualizacion
      );
    };
  }, [
    refresca,
    obtieneSancionesANotificarFirmes,
  ]);

  // ============================================================
  // CATEGORIAS
  // ============================================================

  const categorias = useMemo(() => {
    return listadoSanciones.reduce(
      (acc, sancion) => {
        const estado =
          sancion?.estado ||
          "Sin estado";

        if (!acc[estado]) {
          acc[estado] = [];
        }

        acc[estado].push(sancion);

        return acc;
      },
      {}
    );
  }, [listadoSanciones]);

  // ============================================================
  // MOSTRAR DETALLE
  // ============================================================

  const manejoQueVeo = (
    sancion
  ) => {
    setSancionSeleccionada(sancion);
    setVeoDatosSancion(true);
  };

  // ============================================================
  // HELPERS
  // ============================================================

  const nombreCompleto = (
    sancion
  ) => {
    const apellido =
      sancion?.cadete
        ?.cadeteApellido || "";

    const nombre =
      sancion?.cadete
        ?.cadeteNombre || "";

    return `${apellido} ${nombre}`.trim();
  };

  const obtenerUbicacion = (
    sancion
  ) => {
    const compania =
      sancion?.cadete
        ?.Seccion
        ?.Compania
        ?.nombre;

    const seccion =
      sancion?.cadete
        ?.Seccion
        ?.nombre;

    return [
      compania,
      seccion,
    ]
      .filter(Boolean)
      .join(" · ");
  };

  const obtenerPromocion = (
    sancion
  ) => {
    return (
      sancion?.cadete
        ?.Promocions?.[0]
        ?.nombre || null
    );
  };

  const formatearFecha = (
    fecha
  ) => {
    if (!fecha) {
      return "-";
    }

    const partes =
      String(fecha).split("-");

    if (partes.length === 3) {
      return `${partes[2]}/${partes[1]}/${partes[0]}`;
    }

    return fecha;
  };

  // ============================================================
  // RENDER
  // ============================================================

  return (
    <>
      {/* ====================================================== */}
      {/* MODAL */}
      {/* ====================================================== */}

      {veoDatosSancion &&
        sancionSeleccionada && (
          <ModalSancion
            isOpen={
              veoDatosSancion
            }
            onClose={cerrarModal}
          >
            <div className="san-v2-modal">

              <div className="san-v2-modal-header">

                <span className="san-v2-modal-eyebrow">
                  SANCIÓN FIRME
                </span>

                <h3>
                  Detalle de la sanción
                </h3>

                <p>
                  Actuación disciplinaria
                  confirmada pendiente de
                  notificación final al cadete.
                </p>

              </div>

              <div className="san-v2-selected-person">

                <div className="san-v2-avatar">
                  {sancionSeleccionada
                    ?.cadete
                    ?.cadeteApellido
                    ?.charAt(0)
                    ?.toUpperCase() ||
                    "C"}
                </div>

                <div className="san-v2-selected-info">

                  <span>
                    CADETE
                  </span>

                  <strong>
                    {nombreCompleto(
                      sancionSeleccionada
                    ) ||
                      `DNI ${sancionSeleccionada.cadeteDni}`}
                  </strong>

                  <small>
                    DNI{" "}
                    {
                      sancionSeleccionada
                        .cadeteDni
                    }

                    {" · "}

                    Estado:{" "}
                    {
                      sancionSeleccionada
                        .estado
                    }
                  </small>

                </div>

                <span className="san-v2-section-badge san-v2-badge-green">
                  Firme
                </span>

              </div>

              <div className="san-v2-form-container">

                <Sancion
                  sancionPasada={
                    sancionSeleccionada
                  }
                />

              </div>

            </div>
          </ModalSancion>
        )}

      {/* ====================================================== */}
      {/* CONTENIDO */}
      {/* ====================================================== */}

      <div style={{ width: "100%" }}>

        {/* ==================================================== */}
        {/* RESUMEN */}
        {/* ==================================================== */}

        <div className="san-v2-summary">

          <div className="san-v2-stat-card">

            <div className="san-v2-stat-icon san-v2-stat-icon-confirm">
              ✓
            </div>

            <div>

              <span>
                Firmes pendientes
              </span>

              <strong>
                {cargando
                  ? "..."
                  : listadoSanciones.length}
              </strong>

              <small>
                Sanciones por notificar
              </small>

            </div>

          </div>

        </div>

        {/* ==================================================== */}
        {/* ERROR */}
        {/* ==================================================== */}

        {error && (
          <section
            className="san-v2-section"
            style={{
              borderColor:
                "#fecdca",
            }}
          >
            <div
              className="san-v2-section-content"
              style={{
                padding: "14px",
                color: "#b42318",
              }}
            >
              {error}
            </div>
          </section>
        )}

        {/* ==================================================== */}
        {/* CARGANDO */}
        {/* ==================================================== */}

        {cargando && (
          <section className="san-v2-section">

            <div
              className="san-v2-section-content"
              style={{
                padding: "30px",
                textAlign: "center",
                color: "#667085",
              }}
            >
              Obteniendo sanciones firmes...
            </div>

          </section>
        )}

        {/* ==================================================== */}
        {/* VACIO */}
        {/* ==================================================== */}

        {!cargando &&
          listadoSanciones.length ===
            0 && (
            <section className="san-v2-section">

              <div
                className="san-v2-section-content"
                style={{
                  padding:
                    "35px 20px",
                  textAlign:
                    "center",
                }}
              >

                <div
                  className="san-v2-stat-icon san-v2-stat-icon-confirm"
                  style={{
                    margin:
                      "0 auto 10px",
                  }}
                >
                  ✓
                </div>

                <strong
                  style={{
                    display:
                      "block",
                    color:
                      "#344054",
                    fontSize:
                      "13px",
                  }}
                >
                  Sin sanciones firmes pendientes
                </strong>

                <span
                  style={{
                    display:
                      "block",
                    marginTop:
                      "4px",
                    color:
                      "#98a2b3",
                    fontSize:
                      "11px",
                  }}
                >
                  No existen sanciones pendientes
                  de notificación final.
                </span>

              </div>

            </section>
          )}

        {/* ==================================================== */}
        {/* CATEGORIAS */}
        {/* ==================================================== */}

        {!cargando &&
          Object.entries(
            categorias
          ).map(
            ([
              estado,
              sanciones,
            ]) => (
              <section
                key={estado}
                className="san-v2-section"
              >

                {/* ========================================== */}
                {/* HEADER */}
                {/* ========================================== */}

                <div className="san-v2-section-header">

                  <div className="san-v2-section-title-group">

                    <div className="san-v2-indicator san-v2-indicator-green" />

                    <div>

                      <h2>
                        {estado}
                      </h2>

                      <p>
                        {
                          sanciones.length
                        }{" "}
                        {sanciones.length === 1
                          ? "sanción firme"
                          : "sanciones firmes"}{" "}
                        pendientes de notificación.
                      </p>

                    </div>

                  </div>

                  <span className="san-v2-section-badge san-v2-badge-green">
                    {
                      sanciones.length
                    }
                  </span>

                </div>

                {/* ========================================== */}
                {/* LISTADO */}
                {/* ========================================== */}

                <div className="san-v2-section-content">

                  {sanciones.map(
                    (
                      sancion,
                      index
                    ) => {
                      const ubicacion =
                        obtenerUbicacion(
                          sancion
                        );

                      const promocion =
                        obtenerPromocion(
                          sancion
                        );

                      return (
                        <div
                          key={
                            sancion?.id ||
                            index
                          }
                          className="san-v2-selected-person"
                          style={{
                            margin: "6px",
                            background:
                              "#ffffff",
                          }}
                        >

                          {/* ================================= */}
                          {/* NUMERO */}
                          {/* ================================= */}

                          <div className="san-v2-avatar">
                            {index + 1}
                          </div>

                          {/* ================================= */}
                          {/* DATOS */}
                          {/* ================================= */}

                          <div
                            className="san-v2-selected-info"
                            onClick={() =>
                              manejoQueVeo(
                                sancion
                              )
                            }
                            style={{
                              cursor:
                                "pointer",
                            }}
                          >

                            <span>
                              SANCIÓN FIRME #
                              {sancion?.id ||
                                "-"}
                            </span>

                            <strong>
                              {nombreCompleto(
                                sancion
                              ) ||
                                `DNI ${sancion?.cadeteDni}`}
                            </strong>

                            <small>
                              DNI{" "}
                              {
                                sancion
                                  ?.cadeteDni
                              }

                              {" · "}

                              Fecha:{" "}
                              {formatearFecha(
                                sancion
                                  ?.fechaFaltaCometida
                              )}

                              {sancion
                                ?.cadeteSede
                                ? ` · Sede: ${sancion.cadeteSede}`
                                : ""}

                              {ubicacion
                                ? ` · ${ubicacion}`
                                : ""}

                              {promocion
                                ? ` · Promoción: ${promocion}`
                                : ""}

                              {sancion?.cantidadConfirma
                                ? ` · Cantidad confirmada: ${sancion.cantidadConfirma}`
                                : sancion?.cantidad
                                  ? ` · Cantidad: ${sancion.cantidad}`
                                  : ""}
                            </small>

                          </div>

                          {/* ================================= */}
                          {/* ACCIONES */}
                          {/* ================================= */}

                          <div
                            style={{
                              display:
                                "flex",
                              alignItems:
                                "center",
                              gap: "8px",
                              flexWrap:
                                "wrap",
                            }}
                          >

                            <button
                              type="button"
                              className="san-v2-btn-secondary"
                              onClick={() =>
                                manejoQueVeo(
                                  sancion
                                )
                              }
                            >
                              Ver
                            </button>

                            <button
                              type="button"
                              className="san-v2-btn-primary"
                              onClick={() =>
                                notificarSancion(
                                  sancion
                                )
                              }
                            >
                              ✓ Registrar notificación
                            </button>

                          </div>

                        </div>
                      );
                    }
                  )}

                </div>

              </section>
            )
          )}

      </div>
    </>
  );
};

export default ObtieneSancionesANotificarFirmes;